import React, {ReactElement} from 'react';
import IconWrapper, {IconProps} from '../IconWrapper';

export function IncreaseIcon(props: IconProps): ReactElement {
  return (
    <IconWrapper {...props}>
      <path
        d="M17.3938 13.3702L17.3938 19.6709"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        d="M7.70047 10.5596L7.70047 4.25885"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.64703 14.9739C6.35138 14.9739 5.30078 16.0321 5.30078 17.3371C5.30078 18.642 6.35138 19.7002 7.64703 19.7002C8.94269 19.7002 9.99329 18.642 9.99329 17.3371C9.99329 16.0321 8.94269 14.9739 7.64703 14.9739Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.3541 3.70047C16.0584 3.70047 15.0078 4.75782 15.0078 6.0628C15.0078 7.3686 16.0584 8.42676 17.3541 8.42676C18.6497 8.42676 19.7003 7.3686 19.7003 6.0628C19.7003 4.75782 18.6497 3.70047 17.3541 3.70047Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </IconWrapper>
  );
}
